import { create } from 'zustand';
import { loadSavedCode, saveCode as saveCodeApi } from '../services/code.api';

const useCodeStore = create((set) => ({
  codeByKey: {}, // key `${labInternalId}:${questionId}` -> string
  saving: false,
  error: null,

  async loadCode(labInternalId, questionId) {
    set({ error: null });
    try {
      const res = await loadSavedCode(labInternalId, questionId);
      const content = res?.code || '';
      const key = `${labInternalId}:${questionId}`;
      set((state) => ({ codeByKey: { ...state.codeByKey, [key]: content } }));
      return content;
    } catch (err) {
      set({ error: err });
      throw err;
    }
  },

  async saveCode(labInternalId, questionId, code) {
    set({ saving: true, error: null });
    try {
      await saveCodeApi(labInternalId, questionId, code);
    } catch (err) {
      set({ error: err });
      throw err;
    } finally {
      set({ saving: false });
    }
  },
}));

export default useCodeStore;
